export default __webpack_public_path__ + "static/placement-do-dark-b8a2a94eafa6b0cb680070a6c0c9c7ba.png";